import React from "react";
import { Container, Typography, Box, Link } from "@mui/material";
import locales from "../locales.json";
import { useLang } from "../context/LangContext";

const Terms = () => {
  const { lang } = useLang();
  const { terms_page } = locales;

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: { xs: "center", md: "flex-start" }, // Centre sur mobile
        paddingTop: { xs: "32px", md: "50px" },         // Moins de padding sur mobile
        textAlign: { xs: "center", md: "left" },        // Centre sur mobile
        maxWidth: { xs: "100%", md: "800px" },          // 100% sur mobile, 800px sur desktop
        width: "100%",                                  // Toujours 100% de la largeur
        px: { xs: 2, md: 0 },                           // Padding horizontal sur mobile
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: "bold",
          marginBottom: "20px",
          fontSize: { xs: "2rem", md: "2.5rem" },       // Taille adaptée
          wordBreak: "break-word",
        }}
      >
        {terms_page.title[lang]}
      </Typography>

      <Typography
        variant="h5"
        sx={{
          marginBottom: "20px",
          fontSize: { xs: "1.2rem", md: "1.5rem" },     // Taille adaptée
          wordBreak: "break-word",
        }}
      >
        {terms_page.last_update[lang]}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          marginBottom: "20px",
          fontSize: { xs: "1rem", md: "1.1rem" },
          wordBreak: "break-word",
        }}
      >
        {terms_page.intro[lang]}
      </Typography>

      {terms_page.sections.map((section, index) => (
        <Box key={index} sx={{ marginBottom: "30px", width: "100%" }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              marginBottom: "10px",
              fontSize: { xs: "1.1rem", md: "1.25rem" },
              wordBreak: "break-word",
            }}
          >
            {section.title[lang]}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: "20px",
              fontSize: { xs: "1rem", md: "1.1rem" },
              wordBreak: "break-word",
            }}
          >
            {section.text[lang]}
          </Typography>
        </Box>
      ))}

      <Box sx={{ marginBottom: "30px", width: "100%" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
            wordBreak: "break-word",
          }}
        >
          {terms_page.contact.title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            wordBreak: "break-word",
          }}
        >
          {terms_page.contact.text[lang]}
          <Link href="mailto:contact@medicta.ch">contact@medicta.ch</Link>.
        </Typography>
      </Box>
    </Container>
  );
};

export default Terms;
